export const useAppBreadcrumbs = createGlobalState(() => {
  const { t } = useI18n()
  const items = ref<string[]>([])

  const route = useRoute()

  function setApplication(app: string) {
    items.value.splice(0, 1, app)
  }

  function setItems(newItems: string[]) {
    items.value = [items.value[0], ...newItems]
  }

  const homeRoute = computed(() => {
    // folder-only segments like [[space]] generate unnamed records
    const name = route.matched?.find((record) => record.name)?.name?.toString()
    if (!name || name === '/') return { name: '/' }

    return {
      name: name.endsWith('/') ? name : `${name}/`,
      params: 'space' in route.params ? { space: route.params.space } : {},
    }
  })

  watch(
    () => route.name,
    () => {
      const name = route.name?.toString()

      setItems([])

      if (name?.startsWith('/[[space]]/kb')) {
        setApplication(t('knowledge-base'))
      } else if (name?.startsWith('/tickets')) {
        setApplication('Tickets')
      } else if (name?.startsWith('/[[space]]/chat')) {
        setApplication(t('chat.title'))
      } else if (name?.startsWith('/admin')) {
        setApplication(t('admin.title'))
      } else if (name?.startsWith('/jira')) {
        setApplication('Jira')
      } else if (name?.startsWith('/ops')) {
        setApplication(t('ops.cases'))
      }
    },
    { immediate: true },
  )

  return {
    items,
    homeRoute,
    setItems,
  }
})
